(() => {
  class FjBrandLogos {
    constructor(element) {
      this.element = element;
      this.viewport = element.querySelector('[data-fj-brand-logos-viewport]');
      this.lists = Array.from(element.querySelectorAll('[data-fj-brand-logos-list]'));
      this.looping = false;
      this.stride = 0;
      this.settleTimer = null;

      if (!this.viewport || this.lists.length < 3) return;

      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);

      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.viewport);
      this.update();
    }

    fits() {
      const list = this.lists[1];
      const items = Array.from(list.children);
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      const styles = getComputedStyle(this.viewport);
      const available = this.viewport.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      const needed = items.reduce((sum, item) => sum + item.offsetWidth, 0) + gap * Math.max(items.length - 1, 0);

      return needed <= available;
    }

    update() {
      const shouldLoop = !this.fits();
      const wasLooping = this.looping;

      this.looping = shouldLoop;
      this.element.classList.toggle('fj-brand-logos--loop', shouldLoop);

      if (!shouldLoop) {
        this.viewport.scrollLeft = 0;
        return;
      }

      const stride = this.lists[1].offsetLeft - this.lists[0].offsetLeft;

      if (!wasLooping || stride !== this.stride) {
        this.stride = stride;
        this.viewport.scrollLeft = stride;
      }
    }

    onScroll() {
      if (!this.looping) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
      const nearEnd = scrollLeft < 8 || scrollLeft > scrollWidth - clientWidth - 8;

      clearTimeout(this.settleTimer);

      if (nearEnd) {
        this.wrap();
      } else {
        this.settleTimer = setTimeout(() => this.wrap(), 120);
      }
    }

    wrap() {
      const left = this.viewport.scrollLeft;

      if (left < this.stride) {
        this.viewport.scrollLeft = left + this.stride;
      } else if (left >= this.stride * 2) {
        this.viewport.scrollLeft = left - this.stride;
      }
    }

    destroy() {
      clearTimeout(this.settleTimer);

      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.viewport) this.viewport.removeEventListener('scroll', this.onScroll);
    }
  }

  const instances = new WeakMap();

  function initElement(element) {
    if (instances.has(element)) {
      instances.get(element).destroy();
    }
    instances.set(element, new FjBrandLogos(element));
  }

  document.querySelectorAll('[data-fj-brand-logos]').forEach(initElement);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-fj-brand-logos]').forEach(initElement);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-fj-brand-logos]').forEach((element) => {
      if (instances.has(element)) {
        instances.get(element).destroy();
        instances.delete(element);
      }
    });
  });
})();